module.exports = __webpack_public_path__ + "img/slider1-2.56b29367.png";